import Hover from '../../components/Hover.vue';
import { createApp } from 'vue';

if (document.getElementById('ap-summary-printable-results')) {
    // console.log('ap-summary-printable-results');
    const app = createApp({
        components: {
            Hover
        }
    });
    
    // app.use(pinia);
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#ap-summary-printable-results');
}
